module.exports = __webpack_public_path__ + "img/couples-002.00ea3161.jpg";